function calculateCost({ user, pricing, discounts = [] }, currency, type, recurring) {
  const originalPrice = pricing[currency.toLowerCase()].price,
    percentDiscounts = [],
    setPrices = [];

  for (const x of discounts) {
    if (
      /*
        Checks if the appliesTo rule exists and fits the subscription
      */
      (!x.appliesTo?.type || x.appliesTo?.type === type) &&
      (!x.appliesTo?.recurring || x.appliesTo?.recurring === recurring)
    ) {
      if (x.discountedTo) setPrices.push(x.discountedTo[currency.toLowerCase()].price);
      if (x.amount) percentDiscounts.push(x.amount / 100);
    }
  }

  /* This codeblock has been commented due to logic changes
    /*
      Applies percentage discounts to the original price
    * /
    const discountedValue = percentDiscounts.reduce((acc, discount) => acc * (1 - discount), originalPrice)

    if(setPrices.length) {
      /*
        Return the lowest price out of each possible set price
      * /
      return Math.min(...setPrices, originalPrice) * (recurring === 'annual' ? 12 : 1)
    }
  */

  /*
    Select the lowest price out of all set prices, apply discounts, then add the months
  */
  return (
    percentDiscounts.reduce(
      (acc, discount) => acc * (1 - discount),
      Math.min(...setPrices, originalPrice)
    ) * (recurring === 'annual' ? 12 : 1)
  );
}

export default calculateCost;
